import React from 'react';
import { Create, SimpleForm, TextInput, required } from 'react-admin';

const MarketplaceCreate = (props) => (
	<Create {...props}>
		<SimpleForm variant="standard">
			<TextInput source="name" validate={required()} resettable />
			<TextInput source="walletId" validate={required()} resettable />
		</SimpleForm>
	</Create>
);

export default MarketplaceCreate;
